export default __webpack_public_path__ + "static/media/american.439dde3c.jpg";